import { Spacer } from "@faire/web/slate/spacing";
import React from "react";
export var ConditionalStepper = function ConditionalStepper(_ref) {
  var length = _ref.length,
    index = _ref.index;
  if (length !== 1 && index !== length - 1) {
    return /*#__PURE__*/React.createElement(Spacer, {
      height: "3x"
    });
  }
  return null;
};